import { useMemo } from 'react';
import TopEfficiency from './TopEfficiency';
// import ChartsSection from './ChartsSection';
import ClientEfficiency from './ClientEfficiency';
import EmployeeEfficiency from './EmployeeEfficiency';
import ScopeEfficiency from './ScopeEfficiency';
// import EfficiencyReportsFilter from './EfficiencyReportsFilter';
import EPREfficiencyDonutChart from './EPREfficiencyDonutChart';
import BiometricEfficiencyDonutChart from './BiometricEfficiencyDonutChart';
import { useState } from 'react';

const EfficiencyReports = ({ filters }) => {
  // const [filters, setFilters] = useState({
  //   client: '',
  //   scope: '',
  //   user: '',
  //   startDate: '',
  //   endDate: '',
  //   status: '',
  // });

  // const handleFilterChange = (updatedFilters) => {
  //   const mappedFilters = {
  //     clientId: updatedFilters.client || '',
  //     scopeId: updatedFilters.scope || '',
  //     employeeId: updatedFilters.user || '',
  //     startDate: updatedFilters.startDate || '',
  //     endDate: updatedFilters.endDate || '',
  //     status: updatedFilters.status || '',
  //   };
  //   setFilters(mappedFilters);
  // };
  const mappedFilters = useMemo(
    () => ({
      clientId: filters.client || '',
      scopeId: filters.scope || '',
      employeeId: filters.user || '',
      startDate: filters.startDate || '',
      endDate: filters.endDate || '',
      monthYear: filters.monthYear || '',
    }),
    [filters]
  );

  return (
    <div className="bg-gray-200 space-y-10">
      {/* <div>
        <EfficiencyReportsFilter isChecked={false} onFilterChange={handleFilterChange} />
      </div> */}
      {/* First Section */}
      <div>
        <TopEfficiency filters={mappedFilters} />
      </div>
      <div className="grid md:grid-cols-2 gap-8 px-4 py-6">
        <EPREfficiencyDonutChart filters={mappedFilters} />
        <BiometricEfficiencyDonutChart filters={mappedFilters} />
      </div>
      {/* Second Section */}
      <div className="grid md:grid-cols-2 gap-6 p-4">
        <EmployeeEfficiency filters={mappedFilters} />
        <ScopeEfficiency filters={mappedFilters} />
      </div>

      {/* Third Section */}
      <div className='p-6'>
        <ClientEfficiency filters={mappedFilters} />
      </div>
    </div>
  );
};

export default EfficiencyReports;
